import { useMemo } from 'react';

import { IconEmail } from '@components/icons/email';
import { FilterConfigField } from '@components/table';

import { useStore } from 'models/Provider';

export const useMessageApplicantEmailFilter = (): FilterConfigField => {
  const { t } = useStore();

  return useMemo(
    () => ({
      id: 'emails',
      label: t('messages.filters.email.title'),
      icon: <IconEmail />,
      type: 'email',
      allowedComparers: ['is', 'contains', 'starts'],
      toExternalQuery: (filter) => {
        const value = String(filter.value);

        switch (filter.comparer) {
          case 'is':
            return { application__email__iexact: value };
          case 'contains':
            return { application__email__icontains: value };
          case 'starts':
            return { application__email__startswith: value };
          default:
            return {};
        }
      },
    }),
    [t],
  );
};
